<div class="footer-wrapper">
  <div class="container block">
    <ui-view></ui-view>
  </div>
</div>
